// 模拟数据生成器
export const generateMockData = (seriesType: number, days = 15) => {
  const data = {} as any;
  let chartData = [] as any;
  let tableData = [] as any;
  const date = new Date();

  for (let i = 0; i < days; i++) {
    const value = Math.floor(Math.random() * 50 + 20);
    let type = '';
    if (seriesType === 5) {
      type = '销售' + i;
    } else {
      type = new Date(date.setDate(date.getDate() - 1)).toISOString().split('T')[0];
    }
    let series = [] as any;
    if (seriesType === 1) {
      series = ['5万及以下', '5万-20万', '20万+']

    } else if (seriesType === 2) {
      series = ['0星', '1-2星', '3+星'];
    } else if (seriesType === 3) {
      series = ['分配数', '已跟进'];
    } else if (seriesType === 4) {
      series = ['0星', '1-2星', '3+星'];
    } else if (seriesType === 5) {
      series = ['上门数'];
    }


    chartData = chartData.concat(
      series.map((v: string, i: number) => ({
        type: type,
        value: Math.floor(Math.random() * value * 0.3),
        seriesValue: v,
      }))
    );
    tableData.push(
      {
        type: type,
        valueTotal: Math.floor(Math.random() * 50 + 50),
        value: Math.floor(Math.random() * 50 + 20),
        value1: Math.floor(Math.random() * 50 + 10),
        value2: Math.floor(Math.random() * 50 + 15),
        value3: Math.floor(Math.random() * 50 + 30),
      }
    );

  }
  if (seriesType === 5) {
    chartData = chartData.slice(0, 10).sort((a: any, b: any) => {
      if (a.seriesValue === '新客数') {
        return -1;
      } else if (a.seriesValue === '上门数' && b.seriesValue === '新客数') {
        return 1;
      } else {
        return a.value >= b.value ? 1 : -1;
      }
    });
    tableData = tableData.slice(0, 10);
  }
  data.chartData = chartData.reverse();
  data.tableData = tableData;
  console.log("data: " + seriesType);
  console.log(data);
  return data;
}

// 模拟数据生成器
export const generateMockData1 = (seriesType: number, days = 15) => {
  const data = {} as any;
  let chartData = [] as any;
  let tableData = [] as any;
  let series = [] as any;
  let seriesValue = '';
  if (seriesType === 1 || seriesType === 4 || seriesType === 6) {
    series = ['0星', '1星', '2星', '3星', '4星', '5星'];
    seriesValue = '星级';
  } else if (seriesType === 2 || seriesType === 5 || seriesType === 7) {
    series = ['未处理', '待跟进', '外地客户', '待上门', '已上门', '已签约', '已回款'];
    seriesValue = '客户状态';
  } else if (seriesType === 3) {
    series = ['我的客户', '再分配客户', '重要客户', '公共池', '废物池'];
    seriesValue = '客户类型';
  }

  const value = Math.floor(Math.random() * 50 + 20);
  if (seriesType === 1 || seriesType === 2 || seriesType === 3 || seriesType === 6 || seriesType === 7) {
    series.forEach((v: string) => {
      chartData.push({
        type: v,
        value: Math.floor(Math.random() * value * 0.3),
        seriesValue: seriesValue,
      })
    });

  } else if (seriesType === 4) {
    ['我的客户', '再分配客户', '重要客户', '公共池', '废物池'].map((vo: string) => {
      series.forEach((v: string) => {
        chartData.push({
          type: vo,
          value: Math.floor(Math.random() * value * 0.3),
          seriesValue: v,
        })
      });

      tableData.push(
        {
          type: vo,
          valueTotal: Math.floor(Math.random() * 50 + 50),
          value: Math.floor(Math.random() * 50 + 20),
          value1: Math.floor(Math.random() * 50 + 10),
          value2: Math.floor(Math.random() * 50 + 15),
          value3: Math.floor(Math.random() * 50 + 30),
          value4: Math.floor(Math.random() * 50 + 30),
          value5: Math.floor(Math.random() * 50 + 30),
        }
      );

    })
  } else if (seriesType === 5) {
    ['我的客户', '再分配客户', '重要客户', '公共池', '废物池'].map((vo: string) => {
      series.forEach((v: string) => {
        chartData.push({
          type: vo,
          value: Math.floor(Math.random() * value * 0.3),
          seriesValue: v,
        })
      });

      tableData.push(
        {
          type: vo,
          valueTotal: Math.floor(Math.random() * 50 + 50),
          value: Math.floor(Math.random() * 50 + 20),
          value1: Math.floor(Math.random() * 50 + 10),
          value2: Math.floor(Math.random() * 50 + 15),
          value3: Math.floor(Math.random() * 50 + 30),
          value4: Math.floor(Math.random() * 50 + 30),
          value5: Math.floor(Math.random() * 50 + 30),
        }
      );

    })
  }

  data.chartData = chartData;
  data.tableData = tableData;
  console.log("data: " + seriesType);
  console.log(data);
  return data;
}

